var map = {
	"./avatar_0.png": 42742,
	"./avatar_1.png": 87181,
	"./avatar_10.png": 51466,
	"./avatar_11.png": 34376,
	"./avatar_12.png": 11065,
	"./avatar_13.png": 29069,
	"./avatar_14.png": 13694,
	"./avatar_15.png": 37939,
	"./avatar_16.png": 82362,
	"./avatar_17.png": 85925,
	"./avatar_18.png": 94400,
	"./avatar_19.png": 50232,
	"./avatar_2.png": 3244,
	"./avatar_20.png": 90185,
	"./avatar_3.png": 60650,
	"./avatar_4.png": 4976,
	"./avatar_5.png": 78780,
	"./avatar_6.png": 80529,
	"./avatar_7.png": 6189,
	"./avatar_8.png": 56824,
	"./avatar_9.png": 74117,
	"./card.png": 90576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35046;